import { render, staticRenderFns } from "./TemplateSideCard.vue?vue&type=template&id=52ca4614"
import script from "./TemplateSideCard.vue?vue&type=script&lang=ts"
export * from "./TemplateSideCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports